import {Box, Stack, Typography, useTheme} from '@mui/material';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {ProviderCardProps} from 'domain/usecases/private/communications/get-communications';
import AccordionProviderDetails from '../AccordionProviderDetails';
import {ProviderEnum} from '../../constants/providerEnum';
import StyledBox from './styles';

const {newProvider, unavailableProvider, startDate, endDate} =
	translations['pt-br'].privateFlow.communications;

const ProviderCard = ({provider}: ProviderCardProps) => {
	const theme = useTheme();
	const isNewProvider = provider.type === ProviderEnum.NEW_PROVIDER;
	const getProviderColor = isNewProvider
		? theme.colors.light.primary.dark
		: theme.colors.light.text.secondary;

	return (
		<Fragment>
			<Typography
				variant="body1"
				color="text.primary"
				dangerouslySetInnerHTML={{__html: provider.message ?? ''}}
			/>
			<Stack sx={{backgroundColor: 'background.paper', borderRadius: 1, mt: 2}}>
				<StyledBox $isNewProvider={isNewProvider}>
					<Icon
						name={isNewProvider ? 'group-add' : 'group-remove'}
						color={getProviderColor}
						size={20}
					/>
					<Typography variant="caption" color={getProviderColor}>
						{isNewProvider ? newProvider : unavailableProvider}
					</Typography>
				</StyledBox>
				<Box p="6px 16px">
					<Typography variant="body2" color="text.secondary">
						{isNewProvider ? startDate : endDate}
					</Typography>
					<Typography variant="body1" color="text.primary">
						{provider.date}
					</Typography>
				</Box>
				<AccordionProviderDetails details={provider.details} />
			</Stack>
		</Fragment>
	);
};

export default ProviderCard;
